module.exports = __webpack_public_path__ + "media/images/sport--curling-cf384b62cb7e3e3e7670b708712651b9.png";